import { combineReducers } from "redux";
import utilReducer from "./utilReducer";
import snackReducer from "./snackReducer";

const initialState = {
  values: {},
};

export default combineReducers({
  util: utilReducer,
  snack: snackReducer,
});
